module.exports = __webpack_public_path__ + "img/icon_kf.4744b954.png";